export const rpcUrl = 'https://evm-rpc.planq.network'
